var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0303 11.8333L15.4686 9L12.5921 8.37029M12.5921 8.37029L8.9965 7.58333M12.5921 8.37029L13.3112 4.75H10.4347M8.9965 7.58333V11.125M8.9965 7.58333L5.40089 8.37029M5.40089 8.37029L2.52441 9L3.96265 11.8333M5.40089 8.37029L4.68177 4.75H7.55826M7.55826 4.75V2.625H10.4347V4.75M7.55826 4.75H10.4347M2.52441 14.6667L3.41972 14.3139C3.69807 14.2043 3.99932 14.163 4.29749 14.1936C4.59566 14.2242 4.8818 14.3258 5.13122 14.4896C5.50433 14.7346 5.95517 14.8377 6.39971 14.7796C6.84426 14.7215 7.25219 14.5061 7.54747 14.1737L7.57264 14.1453C7.75022 13.9454 7.96913 13.7852 8.2147 13.6755C8.46027 13.5657 8.72683 13.5089 8.9965 13.5089C9.26616 13.5089 9.53272 13.5657 9.77829 13.6755C10.0239 13.7852 10.2428 13.9454 10.4204 14.1453L10.4462 14.1737C10.7415 14.5061 11.1495 14.7215 11.594 14.7796C12.0385 14.8377 12.4894 14.7346 12.8625 14.4896C13.1119 14.3258 13.398 14.2242 13.6962 14.1936C13.9944 14.163 14.2956 14.2043 14.574 14.3139L15.4686 14.6667",
    stroke: "#555555",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipicon);
export default __webpack_public_path__ + "static/media/shipicon.415cbd1059696e674e6f34769adebc2f.svg";
export { ForwardRef as ReactComponent };